'use strict';

const helper = require('./helper');

const CART_STATUS_UPDATE = 'cart:update';
const PRODUCT_STATUS_UPDATE = 'product:statusUpdate';
const PRICE_SELECTOR = '.price .sales .value';
const ADD_TO_CART_BTN_SELECTOR = '.js-add-to-cart, .js-add-to-cart-global';
const PP_BTN_CONTAINER_SELECTOR = '.attributes, .prices-add-to-cart-actions, .global-availability';

/**
 * Hides a button
 * @param {HTMLElement} buttonEl Button js container
 */
function hideButton(buttonEl) {
    helper.toggleElementVisibility(buttonEl, false);
}

/**
 * Shows a button
 * @param {HTMLElement} buttonEl Button js container
 */
function showButton(buttonEl) {
    helper.toggleElementVisibility(buttonEl, true);
}

/**
 * Hides all buttons on Set.
 * @param {string} selector - The selector for the button.
 * @returns {void}
 */
function hideAllButtonsOnSet(selector) {
    const addToCartButtons = document.querySelectorAll(ADD_TO_CART_BTN_SELECTOR);

    addToCartButtons.forEach((btn) => {
        const paypalButton = btn.closest(PP_BTN_CONTAINER_SELECTOR).querySelector(selector);

        hideButton(paypalButton);
    });
}

/**
 * Check if PDP product price is zero
 * @param {HTMLElement} priceContainerEl - price container element
 * @returns {boolean} "true" in case if PDP product price is zero
 */
function isZeroPdpProductPrice(priceContainerEl) {
    const productPriceEl = priceContainerEl.querySelector(PRICE_SELECTOR);

    if (productPriceEl) {
        const price = parseFloat(productPriceEl.getAttribute('content'), 0);

        return price <= 0;
    }

    return true;
}

/**
 * Is add to cart button disabled
 * @returns {boolean} "true" in case if add to cart button disabled
 */
function isAddToCartButtonDisabled() {
    const addToCartButtonEl = document.querySelector(ADD_TO_CART_BTN_SELECTOR);

    return addToCartButtonEl.disabled;
}

/**
 * Return mini cart quantity
 * @param {HTMLElement} miniCartQuantityElement Mini cart quantity element
 * @returns {number} Quantity
 */
function getMiniCartQuantity(miniCartQuantityElement) {
    return miniCartQuantityElement ? parseInt(miniCartQuantityElement.textContent, 0) : 0;
}

/**
 * Check if basket is empty
 * @returns {boolean} "true" in case if basket is not empty
 */
function isBasketNotEmpty() {
    const MINI_CART_QUANTITY_SELECTOR = '.minicart-quantity';
    const miniCartQuantityElement = document.querySelector(MINI_CART_QUANTITY_SELECTOR);

    return getMiniCartQuantity(miniCartQuantityElement) !== 0;
}

/**
 * Checks if there are any price elements with a value less than or equal to 0.
 * @returns {boolean} Returns true if any price element has a value less than or equal to 0, otherwise false.
 */
function hasInvalidPrice() {
    const prices = Array.from(document.querySelectorAll(PRICE_SELECTOR));

    return prices.some((price) => parseFloat(price.getAttribute('content')) <= 0);
}

/**
 * Handling Paypal and Venmo buttons behavior on Product Set
 * @param {string} ppBtnSelector - selector for PP buttons on product set
 * @returns {void}
 */
function initButtonsBehaviorOnSet(ppBtnSelector) {
    const addToCartButtons = document.querySelectorAll(ADD_TO_CART_BTN_SELECTOR);

    let basketNotEmpty = isBasketNotEmpty();

    addToCartButtons.forEach((btn) => {
        const paypalButton = btn.closest(PP_BTN_CONTAINER_SELECTOR).querySelector(ppBtnSelector);
        const isProductReadyToOrderElement = btn.closest(PP_BTN_CONTAINER_SELECTOR).querySelector('.js-is-show-pp-button');
        const isProductReadyToOrder = isProductReadyToOrderElement && isProductReadyToOrderElement.value === 'true';

        if (!basketNotEmpty && !hasInvalidPrice() && isProductReadyToOrder && !btn.disabled) {
            showButton(paypalButton);
        } else {
            hideButton(paypalButton);
        }
    });

    $('body').on(PRODUCT_STATUS_UPDATE, (event) => {
        const addToCartButton = event.target;
        const paypalButton = addToCartButton.closest(PP_BTN_CONTAINER_SELECTOR).querySelector(ppBtnSelector);

        basketNotEmpty = isBasketNotEmpty();

        if (!basketNotEmpty && !hasInvalidPrice() && !addToCartButton.disabled) {
            showButton(paypalButton);
        } else {
            hideButton(paypalButton);
        }
    });
}

/**
 * Handles PayPal and Venmo buttons behavior on PDP for Product set.
 * @param {string} selector - The selector for the PayPal button.
 * @returns {void}
 */
function initButtonsBehaviorOnPdpSet(selector) {
    initButtonsBehaviorOnSet(selector);

    $('body').on('product:afterAddToCart', () => {
        hideAllButtonsOnSet(selector);
    });

    // Case when buyer remove product from Cart
    $('body').on(CART_STATUS_UPDATE, () => {
        const addToCartButtons = document.querySelectorAll(ADD_TO_CART_BTN_SELECTOR);
        const basketNotEmpty = isBasketNotEmpty();

        addToCartButtons.forEach((btn) => {
            const paypalButton = btn.closest(PP_BTN_CONTAINER_SELECTOR).querySelector(selector);

            if (!basketNotEmpty && !hasInvalidPrice() && !btn.disabled) {
                window.isPayPalSDKLoaded = false;

                showButton(paypalButton);
            } else {
                hideButton(paypalButton);
            }
        });
    });
}

/**
 * Handles Paypal and Venmo buttons behavior on PDP
 * @param {string} selector - PayPal/Venmo button selector
 * @returns {void}
 */
function initButtonsBehaviorOnPdp(selector) {
    const buttonEl = document.querySelector(selector).closest('.js-braintree-pdp-button, .js-braintree-pdp-button-global');

    let addToCartButtonDisabled = isAddToCartButtonDisabled();
    let zeroProductPrice = isZeroPdpProductPrice(buttonEl.parentElement);
    let basketNotEmpty = isBasketNotEmpty();

    if (addToCartButtonDisabled || zeroProductPrice || basketNotEmpty) {
        hideButton(buttonEl);
    }

    $('body').on('product:afterAddToCart', () => {
        hideButton(buttonEl);
    });

    // Case when buyer remove product from Cart
    $('body').on(CART_STATUS_UPDATE, () => {
        const addToCartButtonEnabled = !isAddToCartButtonDisabled();

        zeroProductPrice = isZeroPdpProductPrice(buttonEl.parentElement);
        basketNotEmpty = isBasketNotEmpty();

        if (!basketNotEmpty && addToCartButtonEnabled && !zeroProductPrice) {
            window.isPayPalSDKLoaded = false;

            showButton(buttonEl);
        } else {
            hideButton(buttonEl);
        }
    });

    // When buyer change some attribute of the product on PDP
    $('body').on(PRODUCT_STATUS_UPDATE, () => {
        addToCartButtonDisabled = isAddToCartButtonDisabled();
        zeroProductPrice = isZeroPdpProductPrice(buttonEl.parentElement);
        basketNotEmpty = isBasketNotEmpty();

        if (addToCartButtonDisabled || zeroProductPrice || basketNotEmpty) {
            hideButton(buttonEl);
        } else {
            showButton(buttonEl);
        }
    });
}

/**
 * Init button display behavior on PDP.
 * @param {string} buttonSelector A button selector
 */
function initProductPage(buttonSelector) {
    const isProductSet = Boolean(document.querySelector('.set-items'));

    if (isProductSet) {
        initButtonsBehaviorOnPdpSet(buttonSelector);
    } else {
        initButtonsBehaviorOnPdp(buttonSelector);
    }
}

/**
 * Handling PVP button behavior on Quick View
 * @param {string} selector - PayPal/Venmo button selector
 * @returns {void}
 */
function initButtonBehaviorOnPvp(selector) {
    const quickViewModalEl = document.getElementById('quickViewModal');
    const buttonContainerEl = quickViewModalEl.querySelector(selector).closest('.js-braintree-pvp-button-global, .js-braintree-pvp-button');
    const isProductReadyToOrderElement = document.querySelector('.js-is-show-pp-button');
    const isProductReadyToOrder = isProductReadyToOrderElement && isProductReadyToOrderElement.value === 'true';

    let addToCartButtonDisabled = isAddToCartButtonDisabled();
    let zeroProductPrice = isZeroPdpProductPrice(buttonContainerEl.parentElement);
    let basketNotEmpty = isBasketNotEmpty();

    if (addToCartButtonDisabled || zeroProductPrice || basketNotEmpty || !isProductReadyToOrder) {
        hideButton(buttonContainerEl);
    }

    $('body').on(PRODUCT_STATUS_UPDATE, () => {
        basketNotEmpty = isBasketNotEmpty();
        addToCartButtonDisabled = isAddToCartButtonDisabled();
        zeroProductPrice = isZeroPdpProductPrice(buttonContainerEl.parentElement);

        if (addToCartButtonDisabled || zeroProductPrice || basketNotEmpty) {
            hideButton(buttonContainerEl);
        } else {
            showButton(buttonContainerEl);
        }
    });
}

/**
 * Init PayPal button display behavior. This code is handle only PayPal button on PVP page
 * @param {string} selector - PayPal/Venmo button selector
 * @returns {void}
 */
function initProductViewPage(selector) {
    const buttonEl = document.querySelector(selector);
    const isProductSet = Boolean(document.querySelector('.set-items'));

    if (isProductSet) {
        initButtonsBehaviorOnSet(selector);
    } else if (buttonEl) {
        initButtonBehaviorOnPvp(selector);
    }
}

/**
 * Check if current total basket price is zero
 * @returns {boolean} "true" in case if current total basket price is zero
 */
function isCurrentTotalBasketPriceZero() {
    const basketTotalAmountEl = document.querySelector('.js-sub-total');

    if (!basketTotalAmountEl) {
        return false;
    }

    const basketTotalAmount = basketTotalAmountEl.textContent.slice(1);

    return parseFloat(basketTotalAmount, 10) === 0;
}

/**
 * Show or hide PayPal/Venmo button
 * @param {Object} buttonEl PayPal/Venmo button js container
 */
function minicartButtonBehavior(buttonEl) {
    if (!isCurrentTotalBasketPriceZero()) {
        showButton(buttonEl);
    } else {
        hideButton(buttonEl);
    }
}

module.exports = {
    initProductPage,
    initProductViewPage,
    initButtonsBehaviorOnSet,
    isAddToCartButtonDisabled,
    isZeroPdpProductPrice,
    isBasketNotEmpty,
    hideButton,
    showButton,
    isCurrentTotalBasketPriceZero,
    minicartButtonBehavior
};
